// extracted by mini-css-extract-plugin
module.exports = {"transition":"Transition_transition__TURER"};